import { CURRENT_LOCALES, defaultToLocaleStringOptions } from "shared/numberParser";
import { TimeUnits } from "shared/types";
const THREE_MONTHS_IN_MILLISECONDS = 7776000000;
export const ONE_DAY_IN_MILLISECONDS = 86400000;
export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const getLicenseExpirationStatus = ({ count, start, end, }) => {
    const isFuture = start !== null && new Date(start) > new Date();
    const isExpired = new Date() > new Date(end);
    const isActive = new Date(end) >= new Date() && new Date(start === null ? 0 : start) <= new Date() && count > 0;
    const aboutToExpire = isActive && new Date(end).valueOf() - new Date().valueOf() <= THREE_MONTHS_IN_MILLISECONDS;
    if (isExpired) {
        return "expired";
    }
    else if (!aboutToExpire && isActive) {
        return "active";
    }
    else if (aboutToExpire) {
        return "expires";
    }
    else if (isFuture) {
        return "future";
    }
    return "expired";
};
export const getDateTimeString = (date, options = defaultToLocaleStringOptions) => (date ? (date instanceof Date ? date : new Date(date)) : new Date()).toLocaleString(CURRENT_LOCALES, options);
export const getCurrentDateTimeStamp = () => {
    const now = new Date();
    const month = getDateTimeString(now, { month: "numeric" });
    return `${now.getFullYear()}-${month}-${now.getDate()}_${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
};
export const getTimeUnit = (duration) => {
    if (duration < 60) {
        return TimeUnits.seconds;
    }
    if (duration >= 60 && duration < 3600) {
        return TimeUnits.minutes;
    }
    if (duration >= 3600 && duration < 86400) {
        return TimeUnits.hours;
    }
    return TimeUnits.days;
};
export const getTimePartsFromSeconds = (seconds) => {
    const secNum = Math.ceil(Number(seconds));
    const d = Math.floor(secNum / (3600 * 24));
    const h = Math.floor((secNum - d * 3600 * 24) / 3600);
    const m = Math.floor((secNum - d * 3600 * 24 - h * 3600) / 60);
    const s = Math.floor(secNum - d * 3600 * 24 - h * 3600 - m * 60);
    return { d, h, m, s };
};
export const getDetailedDurationString = (seconds) => {
    const { d, h, m, s } = getTimePartsFromSeconds(seconds);
    const parts = [];
    if (s > 0) {
        parts.unshift(`${s} sec(s)`);
    }
    if (m > 0) {
        parts.unshift(`${m} min(s)`);
    }
    if (h > 0) {
        parts.unshift(`${h} hour(s)`);
    }
    if (d > 0) {
        parts.unshift(`${d} day(s)`);
    }
    return parts.join(", ");
};
export const getSecondsFromConvertedTime = (n, timeUnit) => {
    switch (timeUnit) {
        case TimeUnits.seconds:
            return n;
        case TimeUnits.minutes:
            return Math.round(n * 60);
        case TimeUnits.hours:
            return Math.round(n * 60 * 60);
        case TimeUnits.days:
            return Math.round(n * 60 * 60 * 24);
    }
};
export const toZeroPrefixNotation = (number) => (number < 10 ? `0${number}` : number);
